import React from "react";
import { Whisper, Tooltip } from "rsuite";
import { FiInfo } from "react-icons/fi";

export default function SectionInfoIcon({ text, size = 13 }) {
  if (!text) return null;

  return (
    <Whisper
      placement="top"
      trigger="hover"
      container={() => document.body}
      preventOverflow
      speaker={
        <Tooltip
          className="common__tooltip section-info-tooltip"
          style={{ zIndex: 10050 }}
        >
          {text}
        </Tooltip>
      }
    >
      <span
        role="button"
        tabIndex={0}
        aria-label={text}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#6B7A90",
          cursor: "pointer",
          flexShrink: 0,
          marginLeft: 6,
          lineHeight: 1,
          padding: 2,
        }}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.stopPropagation();
          }
        }}
      >
        <FiInfo size={size} />
      </span>
    </Whisper>
  );
}
